const STAGGER_DELAY = 0.2

export const CONTENT_Y_DISTANCE = 50

export const constructAnimationVars = (direction, isActive, delay = false) => {
    return {
        y: isActive ? 0 : direction * -CONTENT_Y_DISTANCE,
        opacity: isActive ? 1 : 0,
        stagger: delay
            ? {
                  each: STAGGER_DELAY,
                  from: direction == 1 ? 'start' : 'end',
              }
            : false,
        overwrite: true,
    }
}
